module.exports = __webpack_public_path__ + "static/board-460402a5b25c851f0e88f75d77a494bf.png";